import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapState } from "vuex";
import router from "@/router";

export default {
  computed: {
    ...mapState({
      status: (state) => state.Authenticate.forgot_status,
    }),
    router() {
      return router
    },
  },
  data: () => ({
    //
  }),
  async created () {
    if (this.$route.query.access_token ) {
      await this.$store.dispatch(
        "Users/unsubscribe",
        {
          access_token: this.$route.query.access_token
        }
      ).then(result =>{
      }).catch(error => {
        console.error('error:', error);
      });
    }
  },

  components: {
    ValidationProvider,
    ValidationObserver,
  },
};
